export default __webpack_public_path__ + "images/4081160d1adcc73c5f7dc3d7fd0e65c5.png";